import React from 'react';
import Label from "./Label";
import Input from "./Inputs/Input";
import Error from "./Error";
import Select from "./Inputs/Select";
import DetailedLabel from "./DetailedLabel";
import Range from "./Inputs/Range";
import Radio from "./Inputs/Radio";
import DateInput from "./Inputs/DateInput";
import Textarea from "./Inputs/Textarea";
import AccountNumber from "./Inputs/AccountNumber";
import SortCode from "./Inputs/SortCode";

const FormInput = (props) => {
    const {
        name            = '',
        label           = '',
        detailedLabel   = '',
        type            = 'text',
        error           = null
    } = props;

    const renderInput = () => {
        switch (type) {
            case 'radio':
                return (
                    <Radio {...props} />
                );
            case 'range':
                return (
                    <Range {...props} />
                );
            case 'select':
                return (
                    <Select {...props} />
                );
            case 'date':
                return (
                    <DateInput {...props} />
                );
            case 'textarea':
                return (
                    <Textarea {...props} />
                );
            case 'sortcode':
                return (
                    <SortCode {...props} />
                );
            case 'accountnumber':
                return (
                    <AccountNumber {...props} />
                );
            default:
                return (
                    <Input {...props} />
                );
        }
    }

    return (
        <div className={"form-input-container"}>
            <DetailedLabel
                detailedLabel={detailedLabel}
                required={!!props && !!props.required ? props.required : false}
            />
            <div className="form-input">
                <Label name={name} label={label} />
                {renderInput()}
            </div>
            <Error error={!!error && !!error[name] ? error[name] : null} />
        </div>
    );
}

export default FormInput;
